import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import styles from "../../styles/Login.module.css";
import { GoogleSVG } from "../../components/GoogleSVG";

export const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const { login, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!captchaToken) {
      setError("Please complete the reCAPTCHA challenge.");
      return;
    }

    try {
      // Optional: verify captchaToken on backend with secret key
      console.log("Captcha token (email login):", captchaToken);

      // Firebase email/password login
      await login(email, password);
      navigate("/admin/projects");
    } catch (err: any) {
      setError(err.message || "Failed to log in. Check your credentials.");
    }
  };

  const handleGoogleLogin = async () => {
    if (!captchaToken) {
      setError("Please complete the reCAPTCHA challenge.");
      return;
    }

    try {
      // Optional: verify captchaToken on backend
      console.log("Captcha token (Google login):", captchaToken);

      // Firebase Google login
      await signInWithGoogle();
      navigate("/admin/projects");
    } catch (err: any) {
      if (err.code === "auth/popup-closed-by-user") {
        setError("You closed the login popup before completing sign-in.");
      } else {
        setError(err.message || "Failed to log in with Google.");
      }
    }
  };

  return (
    <div className={styles.loginContainer}>
      <h1 className={styles.loginTitle}>Admin Login</h1>
      {error && <p className={styles.errorMessage}>{error}</p>}

      <form onSubmit={handleLogin} className={styles.loginForm}>
        <div className={styles.formGroup}>
          <label>Email</label>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label>Password</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {/* reCAPTCHA */}
        <div className={styles.recaptchaWrapper}>
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
            onChange={(token) => setCaptchaToken(token)}
          />
        </div>

        <button type="submit" className={styles.loginButton}>
          Login
        </button>
      </form>

      <div className={styles.divider}>
        <span>Only For Authorized Admins</span>
      </div>

      <button onClick={handleGoogleLogin} className={styles.googleButton}>
        <GoogleSVG className={styles.googleIcon} size={22} />
        Sign in with Google
      </button>
    </div>
  );
};
